import React from "react"
import autobind from "class-autobind"
import ShiftTemplatesChip from "./ShiftTemplatesChip"
import { IScheduleShift, IClientDocument, IJobDocument } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
interface IProps {
  shiftTemplate: IScheduleShift
  hierarchyId: string
  handleSave(shiftTemplate: IScheduleShift): void
  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}
interface IState {
  shiftTemplate: IScheduleShift
}

export default class CreateSimplePositionShift extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      shiftTemplate: null
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    !_.isEqual(this.props.shiftTemplate, nextProps.shiftTemplate) &&
      this.setState({ shiftTemplate: nextProps.shiftTemplate })
  }

  render() {
    return (
      <div style={{ height: 80 }}>
        <ShiftTemplatesChip
          requireOneItem
          errorText={this.state.shiftTemplate ? "" : strings.This_field_is_required}
          shiftTemplates={this.state.shiftTemplate ? [this.state.shiftTemplate] : []}
          shiftTemplateHierarchyId={this.props.hierarchyId}
          handleChange={(shiftTemplates) => this.setState({ shiftTemplate: shiftTemplates.length ? shiftTemplates[0] : null }, () => this.props.handleSave(this.state.shiftTemplate))}
          scheduleJob={this.props.scheduleJob}
          scheduleClient={this.props.scheduleClient}
        />
      </div>
    )
  }
}